module.exports = __webpack_public_path__ + "2ec84b604f1b6f8424ddeb7ba24b7144.svg";